<template>
    <select class="v-request-options-dropdown" :value="selectedValue" :disabled="disabled" @change="onChange($event)">
        <option v-if="option.allowUnselect && !hasSelection" value="">
            - Keine Auswahl -
        </option>
        <option v-for="item of option.options" :key="item.value" :value="item.value">
            {{ item.label || item.value }}
        </option>
    </select>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { DropdownRequestOptionsItem } from 'atlas-shared/dist/RequestOptions';

/**
 * Renders a request option of type `"Dropdown"` as a native HTML `<select>`.
 *
 * The selected value is emitted via `update:modelValue` on change, so the
 * parent (`RequestOptionsPanel`) can update the request settings.
 */

const props = defineProps<{
    option: DropdownRequestOptionsItem;
    modelValue: any;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    'update:modelValue': [value: any];
}>();

const hasSelection = computed(() =>
    props.option.options.some(item => item.value === props.modelValue)
);

/**
 * The value bound to the native `<select>`. If the current modelValue is not one
 * of the option values (e.g. because the option list changed), we fall back to
 * the first option without emitting — we must not "correct" the modelValue.
 */
const selectedValue = computed(() => {
    if (hasSelection.value) return props.modelValue
    return props.option.options[0]?.value ?? ''
});

function onChange(event: Event) {
    emit('update:modelValue', (event.target as HTMLSelectElement).value)
}
</script>

<style scoped>
.v-request-options-dropdown {
    width: 100%;
}
</style>
